export const APP_NAME = 'mensajeria';
